export default [
  {
    path: 'M765.056 968.96H262.784C148.736 968.96 56.32 876.544 56.32 762.496V260.224C56.32 146.176 148.736 53.76 262.784 53.76h502.272C879.104 53.76 971.52 146.176 971.52 260.224v502.272c-0.128 114.048-92.544 206.464-206.464 206.464z',
    fill: '#0079F5',
  },

  {
    path: 'M513.92 307.968c-109.184 0-209.536 39.424-287.104 105.088-4.224 3.584-4.48 10.24-0.512 14.208l30.464 30.464c3.456 3.456 8.96 3.584 12.672 0.512 66.56-55.168 151.808-88.192 244.48-88.192s177.92 33.024 244.48 88.192c3.712 3.072 9.216 2.944 12.672-0.512l30.464-30.464c3.968-3.968 3.712-10.624-0.512-14.208-77.696-65.664-178.048-105.088-287.104-105.088z',
    fill: '#FFFFFF',
  },
  {
    path: 'M514.048 449.664c-70.272 0-134.656 24.064-185.6 64.512-4.48 3.584-4.736 10.24-0.64 14.336l32 32c3.328 3.328 8.576 3.584 12.416 0.768 39.296-30.08 88.704-47.744 141.824-47.744s102.528 17.664 141.824 47.744c3.84 2.944 9.088 2.688 12.416-0.768l31.744-31.744c3.968-3.968 3.712-10.752-0.64-14.336-50.944-40.576-115.456-64.768-185.344-64.768zM596.992 631.68l-76.416 76.416c-3.712 3.712-9.728 3.712-13.44 0l-76.416-76.416c-3.712-3.712-3.84-9.984-0.128-13.568 21.76-20.48 51.072-33.024 83.2-33.024s61.44 12.544 83.2 33.024c3.968 3.584 3.712 9.856 0 13.568z',
    fill: '#FFFFFF',
  },
]
